




import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductTuple } from '@/stores/search/util';
import ProductImage from '@/views/product/common/ProductImage.vue';

@Component({
  components: {ProductImage},
})
export default class ProductTitle extends Vue {
  @Prop({required: true})
  private product!: ProductTuple;
}
